module.exports = __webpack_public_path__ + "img/slide1_img1.9c9d776b.png";